(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1075],{

/***/ 95167:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"initStudentPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initStudentPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sharedSecretKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":165}};
    doc.loc.source = {"body":"mutation initStudentPassword($user: String, $password: String) {\n  initStudentPassword(user: $user, password: $password) {\n    _id\n    sharedSecretKey\n    type\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.initStudentPassword = oneQuery(doc, "initStudentPassword");
        


/***/ }),

/***/ 72186:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FindUserInput"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasPassword"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":98}};
    doc.loc.source = {"body":"query findUser($input: FindUserInput) {\n  findUser(input: $input) {\n    _id\n    hasPassword\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.findUser = oneQuery(doc, "findUser");
        


/***/ }),

/***/ 92327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83058);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var LinkContent = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Link__LinkContent",
  componentId: "sc-1jumwjv-0"
})(["cursor:pointer;"]);

var Link = function Link(props) {
  var replace = props.replace,
      href = props.href,
      to = props.to,
      children = props.children;

  var handleClick = function handleClick(ev) {
    if (replace && href) {
      ev.preventDefault();
      window.location.replace(href);
    }
  };

  if (!to && !href) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      children: children
    });
  }

  return to ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
    href: to.replace('/edu', ''),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(LinkContent, {
      children: children
    })
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", _objectSpread(_objectSpread({
    href: href,
    onClick: handleClick
  }, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
      children: children
    })
  }));
};

Link.navigate = function (props) {
  var link = typeof props === 'string' ? props : props.to || props.href;
  var replace = props.replace;

  if (replace) {
    window.location.replace(link);
  } else {
    window.location.assign(link);
  }
};

/* harmony default export */ __webpack_exports__["Z"] = (Link);

/***/ }),

/***/ 81995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Loader; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(83058);
;// CONCATENATED MODULE: ./components/UI/Loader/Loader.styles.js

var LoaderWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Loaderstyles__LoaderWrap",
  componentId: "sc-181vwt-0"
})(["color:transparent;position:", ";height:100%;width:100%;top:0;bottom:0;right:0;left:0;text-indent:-9999px;z-index:99991;background-color:", ";"], function (props) {
  return props.fullscreen ? 'fixed' : 'absolute';
}, function (props) {
  return props.bgColor;
});
var LoaderAnimate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Loaderstyles__LoaderAnimate",
  componentId: "sc-181vwt-1"
})(["background:inherit;display:inline-block;position:absolute;left:50%;top:50%;"]);
var LoaderMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Loaderstyles__LoaderMessage",
  componentId: "sc-181vwt-2"
})(["  text-indent:0;color:", ";font-size:", ";", ";text-align:center;position:relative;"], function (props) {
  return props.color;
}, function (props) {
  return props.fontSize;
}, function (props) {
  return (0,styled_components_browser_esm/* css */.iv)(["width:100%;top:calc(50% + ", "px);"], props.itemSize * 0.75);
});
var StyledLoader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Loaderstyles__StyledLoader",
  componentId: "sc-181vwt-3"
})(["& > svg{display:inline-block;position:absolute;", ";overflow:show;margin:auto;text-indent:-9999em;animation:spin 1.5s linear infinite;fill:", ";height:", "px;width:", "px;@keyframes spin{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg);}}"], function (props) {
  return (0,styled_components_browser_esm/* css */.iv)(["top:calc(50% - ", "px);left:calc(50% - ", "px);"], props.itemSize / 2, props.itemSize / 2);
}, function (props) {
  return props.itemColor;
}, function (props) {
  return props.itemSize;
}, function (props) {
  return props.itemSize;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/UI/Loader/Loader.js






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






var Loader = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(Loader, _Component);

  var _super = _createSuper(Loader);

  function Loader() {
    (0,classCallCheck/* default */.Z)(this, Loader);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(Loader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          bgColor = _this$props.bgColor,
          itemColor = _this$props.itemColor,
          itemSize = _this$props.itemSize,
          fullscreen = _this$props.fullscreen,
          message = _this$props.message,
          fontSize = _this$props.fontSize;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(LoaderWrap, {
        bgColor: bgColor,
        itemSize: itemSize,
        fullscreen: fullscreen,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LoaderAnimate, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLoader, {
            itemColor: itemColor,
            itemSize: itemSize,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
              version: "1.1",
              id: "Layer_1",
              xmlns: "http://www.w3.org/2000/svg",
              xmlnsXlink: "http://www.w3.org/1999/xlink",
              x: "0px",
              y: "0px",
              viewBox: "0 0 64 64",
              xmlSpace: "preserve",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                d: "M32,0C14.4,0,0,14.4,0,32s14.3,32,32,32s32-14.3,32-32C64,14.4,49.6,0,32,0z M36.3,21.2L35,22.9c-0.9,1.2-2,2.5-3,3.6c-1-1.2-2-2.5-3-3.6l-1.4-1.7c-3.6-4.4-3.6-10.1-3.3-13.1c4.9-1.6,10.4-1.6,15.2,0C39.9,11.1,39.9,16.8,36.3,21.2z M17.7,11.3c0.1,4,1.2,9.4,4.9,14l1.4,1.7c1.3,1.6,2.6,3.1,3.8,4.7c-2.9,3.5-4.9,6.2-5.2,6.5c-3.9,4.8-4.8,10.3-4.9,14.4C10.9,48,6.8,40.3,6.8,32C6.9,23.7,10.9,16,17.7,11.3z M27.7,42.3L27.7,42.3c0.4-0.4,2.1-2.5,4.3-5.5c2.5,3.1,4.3,5.3,4.3,5.5c3.8,4.7,3.6,10.8,3.3,13.7c-4.9,1.6-10.3,1.6-15.2,0C24.1,53.1,23.8,47.1,27.7,42.3z M46.3,52.7c0-4.2-1-9.6-4.9-14.4v-0.1c-0.4-0.5-2.5-3.1-5.2-6.5c1.3-1.6,2.6-3.1,3.8-4.7l1.4-1.7c3.8-4.7,4.8-10,4.9-14c6.8,4.7,10.9,12.4,10.9,20.7C57.1,40.3,53.1,48,46.3,52.7z"
              })
            })
          })
        }), message && /*#__PURE__*/(0,jsx_runtime.jsx)(LoaderMessage, {
          itemSize: itemSize,
          color: itemColor,
          fontSize: fontSize,
          children: message
        })]
      });
    }
  }]);

  return Loader;
}(react.Component);



/***/ }),

/***/ 1536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modal; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-spring/dist/react-spring.esm.js
var react_spring_esm = __webpack_require__(39920);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(83058);
// EXTERNAL MODULE: ./node_modules/nzk-react-components/dist/esm/components/Button/Button.js + 2 modules
var Button = __webpack_require__(62058);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/UI/Icons/Close.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Svg = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
  displayName: "Close__Svg",
  componentId: "sc-15lcvsn-0"
})(["height:", "px;width:", "px;"], function (props) {
  return props.size || props.height;
}, function (props) {
  return props.size || props.width;
});
/* harmony default export */ var Close = (function (props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Svg, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: "0 0 120 120",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "Path_122",
        x: "3.799",
        y: "6",
        width: "113.103",
        height: "117.103",
        filterUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feOffset", {
          dy: "4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          result: "blur"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: "0.4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
          operator: "in",
          in2: "blur"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
          "in": "SourceGraphic"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
      id: "Frame",
      width: "120",
      height: "120",
      transform: "translate(0 1)",
      fill: "none"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      transform: "matrix(1, 0, 0, 1, 0, 0)",
      filter: "url(#Path_122)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        id: "Path_122-2",
        "data-name": "Path 122",
        d: "M78.767,50.339a5.231,5.231,0,0,0,1.4-3.834l-.244-10.863A5.457,5.457,0,0,0,78.2,31.588a5.694,5.694,0,0,0-3.9-1.575l-23.362-.524-.6-23.44a5.319,5.319,0,0,0-1.575-3.9A5.206,5.206,0,0,0,44.78.5L33.916.253a4.885,4.885,0,0,0-3.836,1.4,4.944,4.944,0,0,0-1.473,3.908L29.059,29l-23.507-.38a5.056,5.056,0,0,0-3.836,1.4A4.939,4.939,0,0,0,.242,33.927L.558,44.718A5.019,5.019,0,0,0,2.209,48.7a4.6,4.6,0,0,0,3.9,1.575l23.438.6.527,23.51a4.943,4.943,0,0,0,1.575,3.9C32.87,79.5,34,80.2,35.63,79.935l10.789.316a5.715,5.715,0,0,0,3.908-1.474,5.223,5.223,0,0,0,1.4-3.836l-.305-23.579,23.51.528A5.156,5.156,0,0,0,78.767,50.339Z",
        transform: "translate(60.37 5.66) rotate(45)",
        fill: "#afafaf"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      id: "Path_1217",
      "data-name": "Path 1217",
      d: "M78.767,50.339a5.231,5.231,0,0,0,1.4-3.834l-.244-10.863A5.457,5.457,0,0,0,78.2,31.588a5.693,5.693,0,0,0-3.9-1.575l-23.362-.524-.6-23.44a5.319,5.319,0,0,0-1.575-3.9A5.206,5.206,0,0,0,44.78.5L33.916.253a4.884,4.884,0,0,0-3.836,1.4,4.943,4.943,0,0,0-1.473,3.908L29.059,29l-23.507-.38a5.054,5.054,0,0,0-3.836,1.4A4.94,4.94,0,0,0,.242,33.927L.558,44.718A5.021,5.021,0,0,0,2.209,48.7a4.6,4.6,0,0,0,3.9,1.575l23.438.6.527,23.51a4.943,4.943,0,0,0,1.575,3.9C32.87,79.5,34,80.2,35.631,79.935l10.788.316a5.715,5.715,0,0,0,3.908-1.474,5.224,5.224,0,0,0,1.4-3.836l-.306-23.579,23.51.528A5.157,5.157,0,0,0,78.767,50.339Z",
      transform: "translate(60.375 -0.339) rotate(45)",
      fill: "#fff"
    })]
  }));
});
// EXTERNAL MODULE: ./node_modules/lodash-es/words.js + 3 modules
var words = __webpack_require__(10331);
;// CONCATENATED MODULE: ./components/UIv2/Modal/index.tsx


function Modal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Modal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Modal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Modal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(react_spring_esm.animated.div).withConfig({
  displayName: "Modal__Wrapper",
  componentId: "sc-1m49erj-0"
})(["position:absolute;background-color:#341644;color:#fff;border-radius:45px;max-height:512px;width:760px;display:flex;flex-direction:column;padding-bottom:15px;box-shadow:0 -5px 0 #531D75,0 10px 0 #1C042B,0 14px 0 rgba(0,0,0,0.3);"]);
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Modal__Header",
  componentId: "sc-1m49erj-1"
})(["position:relative;display:flex;text-align:center;padding:0 30px;transform:translateY(-50%);padding-bottom:20px;"]);
var Titles = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Modal__Titles",
  componentId: "sc-1m49erj-2"
})(["font-family:'Rammetto One';margin:0 25px;flex:1;"]);
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Modal__Title",
  componentId: "sc-1m49erj-3"
})(["font-size:37px;line-height:48px;color:#fff;text-shadow:0 5px 0 #AFAFAF,0 8px 0 rgba(0,0,0,0.5);"]);
var SubTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Modal__SubTitle",
  componentId: "sc-1m49erj-4"
})(["font-size:", ";color:#8E38B4;margin-top:-10px;text-shadow:0 4px 0 #560084,0 7px 0 rgba(0,0,0,0.5);"], function (props) {
  return props.subtitleIsLong ? '19px' : '23px';
});
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Modal__Content",
  componentId: "sc-1m49erj-5"
})(["position:relative;flex:1;height:100%;margin:0 auto;display:flex;flex-direction:column;gap:20px;margin-top:-25px;width:calc(100% - 140px);border-radius:12px;"]);
var QuitButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Modal__QuitButton",
  componentId: "sc-1m49erj-6"
})(["position:absolute;top:0px;right:0;transform:translate(20%,-20%);z-index:2;"]);
/* harmony default export */ var Modal = (function (_ref) {
  var title = _ref.title,
      description = _ref.description,
      children = _ref.children,
      _ref$enterAnimationDe = _ref.enterAnimationDelay,
      enterAnimationDelay = _ref$enterAnimationDe === void 0 ? 1000 : _ref$enterAnimationDe,
      _ref$enterAnimationTy = _ref.enterAnimationType,
      enterAnimationType = _ref$enterAnimationTy === void 0 ? 'slideInUp' : _ref$enterAnimationTy,
      dismiss = _ref.dismiss;
  var from = {
    x: 0,
    y: 0
  };

  switch (enterAnimationType) {
    case 'slideInUp':
      from.y = window.innerHeight;
      break;

    case 'slideInLeft':
      from.x = -window.innerWidth;
      break;

    case 'slideInRight':
      from.x = window.innerWidth;
      break;
  }

  var springOptions = {
    from: from,
    x: 0,
    y: 0,
    delay: enterAnimationDelay,
    immediate: enterAnimationType === 'none'
  };

  var _useSpring = (0,react_spring_esm.useSpring)(springOptions),
      x = _useSpring.x,
      y = _useSpring.y;

  var transforms = function transforms() {
    return {
      slideInUp: {
        y: y
      },
      slideInLeft: {
        x: x
      },
      slideInRight: {
        x: x
      },
      none: {}
    };
  };

  var subtitleIsLong = (0,words/* default */.Z)(description).length > 14;

  var onWrapperClick = function onWrapperClick(e) {
    e.stopPropagation();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    className: "modal",
    onClick: onWrapperClick,
    style: Modal_objectSpread({}, transforms()[enterAnimationType]),
    children: [dismiss && /*#__PURE__*/(0,jsx_runtime.jsx)(QuitButton, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        size: "regular",
        backgroundColor: "#EC1A18",
        round: true,
        onClick: dismiss,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Close, {})
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Titles, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubTitle, {
          subtitleIsLong: subtitleIsLong,
          dangerouslySetInnerHTML: {
            __html: description || ''
          }
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Content, {
      className: "modal--content",
      children: children
    })]
  });
});

/***/ }),

/***/ 86624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ getParameterByName; }
/* harmony export */ });
var getParameterByName = function getParameterByName(name) {
  var match;
  match = window.location.search.match(RegExp('[?&]' + name + '=([^&]*)'));

  if (match) {
    return decodeURIComponent(match[1].replace(+/g/, ' '));
  } else {
    return null;
  }
};

/***/ }),

/***/ 1163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/nzk-react-components/dist/esm/components/Button/Button.js + 2 modules
var Button = __webpack_require__(62058);
// EXTERNAL MODULE: ./components/UI/Icon/Icon.js
var Icon = __webpack_require__(77032);
// EXTERNAL MODULE: ./components/UI/Loader/Loader.js + 1 modules
var Loader = __webpack_require__(81995);
// EXTERNAL MODULE: ./lib/qs.js
var qs = __webpack_require__(86624);
// EXTERNAL MODULE: ./components/UI/Button/Button.js + 1 modules
var Button_Button = __webpack_require__(93195);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(83058);
// EXTERNAL MODULE: ./themes/styles/fonts.js
var fonts = __webpack_require__(11436);
;// CONCATENATED MODULE: ./pages/zoo/login/ZooLogin.styles.js



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ZooLoginstyles__Wrapper",
  componentId: "sc-3aj86n-0"
})(["min-width:100vw;min-height:540px;height:100%;overflow:hidden;background-image:url(\"", "/images/welcome-bg.jpg\");background-size:cover;background-position:center;position:absolute;top:0;left:0;", ";"], "/edu/assets", fonts/* default.libreBaskerville */.Z.libreBaskerville);
var PasswordForgotten = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ZooLoginstyles__PasswordForgotten",
  componentId: "sc-3aj86n-1"
})(["max-width:300px;margin:0 auto;margin-top:30px;a{text-decoration:underline;}"]);
var Clipboard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ZooLoginstyles__Clipboard",
  componentId: "sc-3aj86n-2"
})(["position:relative;padding:40px;height:100%;color:#191464;text-align:center;background-color:#e8e8e8;"]);
var ClipboardContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ZooLoginstyles__ClipboardContainer",
  componentId: "sc-3aj86n-3"
})(["position:absolute;z-index:1;max-width:960px;width:600px;height:calc(100% - 100px);border-radius:20px 20px 0 0;background-color:#744d24;background-image:linear-gradient( to bottom,#744d24 0%,rgba(0,0,0,0.4) 100% );padding:20px 20px 0 20px;margin:100px auto auto auto;box-shadow:0 -10px 0 0 #936c43;left:50%;transform:translateX(-50%);"]);
var Form = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ZooLoginstyles__Form",
  componentId: "sc-3aj86n-4"
})([""]);
var StyledInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
  displayName: "ZooLoginstyles__StyledInput",
  componentId: "sc-3aj86n-5"
})(["left:0;width:300px;border-radius:20px;padding:10px;font-size:20px;border:3px solid ", ";margin-bottom:5px;"], function (props) {
  return props.isWrong ? 'red' : '#191464';
});
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "ZooLoginstyles__Title",
  componentId: "sc-3aj86n-6"
})(["width:100%;font-size:24px;text-align:center;", ";text-transform:uppercase;letter-spacing:1px;font-size:24px;line-height:1.3;margin:0 0 25px 0;"], fonts/* default.rammetto */.Z.rammetto);
var Field = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ZooLoginstyles__Field",
  componentId: "sc-3aj86n-7"
})(["margin-bottom:25px;"]);
var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ZooLoginstyles__Label",
  componentId: "sc-3aj86n-8"
})(["width:100%;text-align:center;font-size:19px;margin-bottom:10px;"]);
var ErrorMessage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ZooLoginstyles__ErrorMessage",
  componentId: "sc-3aj86n-9"
})(["font-style:italic;color:red;"]);
var GoogleErrorMessage = (0,styled_components_browser_esm/* default */.ZP)(ErrorMessage).withConfig({
  displayName: "ZooLoginstyles__GoogleErrorMessage",
  componentId: "sc-3aj86n-10"
})(["font-style:italic;color:red;margin-bottom:15px;"]);
var GoogleSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ZooLoginstyles__GoogleSection",
  componentId: "sc-3aj86n-11"
})(["width:195px;margin:35px auto 0 auto;"]);
var ClipboardClip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ZooLoginstyles__ClipboardClip",
  componentId: "sc-3aj86n-12"
})(["position:absolute;left:50%;top:-40px;z-index:2;margin-left:-150px;width:300px;height:80px;background-image:url(\"", "/images/clipboard.png\");background-position:center;background-repeat:no-repeat;background-size:contain;"], "/edu/assets");
var ClassCode = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ZooLoginstyles__ClassCode",
  componentId: "sc-3aj86n-13"
})(["margin-top:50px;font-size:14px;color:#808080;& a{text-decoration:underline;color:inherit;}"]);
var PreviousStepButton = (0,styled_components_browser_esm/* default */.ZP)(Button_Button/* default */.Z).withConfig({
  displayName: "ZooLoginstyles__PreviousStepButton",
  componentId: "sc-3aj86n-14"
})(["position:absolute;top:32px;left:25px;"]);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/zoo/login/ZooLogin.js









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }










var Login = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(Login, _Component);

  var _super = _createSuper(Login);

  function Login(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Login);

    _this = _super.call(this, props);
    _this.state = {
      fieldErrors: [null],
      step: 0,
      userId: null,
      username: '',
      loading: false,
      errorMessage: undefined,
      googleErrorMessage: undefined,
      fromParent: false
    };
    return _this;
  }

  (0,createClass/* default */.Z)(Login, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var params = new URLSearchParams(location.search);
      var username = params.get('username');

      if (username) {
        this.setState({
          username: username,
          fromParent: true
        }, function () {
          _this2.onUsernameSubmit();
        });
      }
    }
  }, {
    key: "onUsernameSubmit",
    value: function () {
      var _onUsernameSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var data;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.getUser(this.state.username.toLowerCase());

              case 2:
                data = _context.sent;

                if (data.findUser) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", this.setState({
                  fieldErrors: ["This username isn't correct"]
                }));

              case 5:
                this.setState({
                  fieldErrors: [null],
                  userId: data.findUser._id,
                  step: data.findUser.hasPassword ? 1 : 2
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onUsernameSubmit() {
        return _onUsernameSubmit.apply(this, arguments);
      }

      return onUsernameSubmit;
    }()
  }, {
    key: "onPasswordLoginSubmit",
    value: function () {
      var _onPasswordLoginSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
        var _this3 = this;

        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({
                  loading: true
                });
                this.props.login({
                  username: this.state.username.toLowerCase(),
                  password: this.passwordInput.value
                }).then( /*#__PURE__*/function () {
                  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(data) {
                    var loginRedirect;
                    return regenerator_default().wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.prev = 0;
                            loginRedirect = (0,qs/* getParameterByName */.a)('redirect');

                            if (!loginRedirect) {
                              _context2.next = 5;
                              break;
                            }

                            window.location.assign(loginRedirect);
                            return _context2.abrupt("return");

                          case 5:
                            _this3.props.router.push('/zoo/map');

                            _context2.next = 11;
                            break;

                          case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2["catch"](0);

                            _this3.setState({
                              loading: false,
                              errorMessage: _context2.t0.message,
                              fieldErrors: ['']
                            });

                          case 11:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[0, 8]]);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }())["catch"](function (e) {
                  _this3.setState({
                    loading: false,
                    errorMessage: 'Invalid email or password',
                    fieldErrors: ['Incorrect password! Passwords are case sensitive - please check CAPS LOCK.']
                  });
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onPasswordLoginSubmit() {
        return _onPasswordLoginSubmit.apply(this, arguments);
      }

      return onPasswordLoginSubmit;
    }()
  }, {
    key: "onPasswordRegisterSubmit",
    value: function () {
      var _onPasswordRegisterSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
        var _this4 = this;

        return regenerator_default().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.setState({
                  loading: true
                });
                this.props.initStudentPassword(this.state.userId, this.passwordInput.value).then( /*#__PURE__*/function () {
                  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(_ref2) {
                    var data;
                    return regenerator_default().wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            data = _ref2.data;

                            _this4.props.login({
                              username: _this4.state.username.toLowerCase(),
                              password: _this4.passwordInput.value
                            }).then( /*#__PURE__*/function () {
                              var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(_ref4) {
                                var data;
                                return regenerator_default().wrap(function _callee4$(_context4) {
                                  while (1) {
                                    switch (_context4.prev = _context4.next) {
                                      case 0:
                                        data = _ref4.data;

                                        try {
                                          _this4.props.router.push('/zoo/map');
                                        } catch (e) {
                                          console.error(e);

                                          _this4.setState({
                                            loading: false,
                                            errorMessage: e.message
                                          });
                                        }

                                      case 2:
                                      case "end":
                                        return _context4.stop();
                                    }
                                  }
                                }, _callee4);
                              }));

                              return function (_x3) {
                                return _ref5.apply(this, arguments);
                              };
                            }());

                          case 2:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }())["catch"](function (e) {
                  _this4.setState({
                    loading: false,
                    errorMessage: 'Invalid email or password'
                  });
                });

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function onPasswordRegisterSubmit() {
        return _onPasswordRegisterSubmit.apply(this, arguments);
      }

      return onPasswordRegisterSubmit;
    }()
  }, {
    key: "onFormChange",
    value: function onFormChange(values) {
      var formData = values;
      this.props.changeLoginForm(formData);
    }
  }, {
    key: "renderEnterUsernameForm",
    value: function renderEnterUsernameForm() {
      var _this5 = this;

      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Form, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Field, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
              children: "Enter your username"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledInput, {
              isWrong: this.state.fieldErrors[0],
              placeholder: "Username",
              ref: function ref(u) {
                return _this5.usernameInput = u;
              },
              defaultValue: this.state.username,
              onChange: function onChange(e) {
                return _this5.setState({
                  username: e.target.value
                });
              },
              onKeyPress: function onKeyPress(e) {
                return e.which == 13 && _this5.onUsernameSubmit();
              }
            }), this.state.fieldErrors[0] && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
              children: this.state.fieldErrors[0]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            size: "regular",
            theme: "primary",
            onClick: this.onUsernameSubmit.bind(this),
            children: "Continue"
          })]
        })
      });
    }
  }, {
    key: "renderExistingUserForm",
    value: function renderExistingUserForm() {
      var _this6 = this;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Form, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Field, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
            children: "Enter your password"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledInput, {
            isWrong: this.state.fieldErrors[0],
            ref: function ref(p) {
              return _this6.passwordInput = p;
            },
            placeholder: "Password",
            type: "password",
            onKeyPress: function onKeyPress(e) {
              return e.which == 13 && _this6.onPasswordLoginSubmit();
            }
          }), this.state.fieldErrors[0] && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: this.state.fieldErrors[0]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          size: "regular",
          theme: "primary",
          onClick: this.onPasswordLoginSubmit.bind(this),
          children: "Continue"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PasswordForgotten, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Forgotten your password?"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["Your parent or teacher can reset your password in", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://dashboard.nightzookeeper.com",
              target: "_blank",
              rel: "noreferrer noopener",
              children: "their dashboard."
            })]
          })]
        })]
      });
    }
  }, {
    key: "renderNewUserForm",
    value: function renderNewUserForm() {
      var _this7 = this;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Form, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Field, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
            children: this.state.fromParent ? "Create a password for ".concat(this.state.username) : 'Create your password'
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledInput, {
            isWrong: this.state.fieldErrors[0],
            placeholder: "Password",
            type: "password",
            ref: function ref(p) {
              return _this7.passwordInput = p;
            },
            onKeyPress: function onKeyPress(e) {
              return e.which == 13 && _this7.onPasswordRegisterSubmit();
            }
          }), this.state.fieldErrors[0] && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorMessage, {
            children: this.state.fieldErrors[0]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          size: "regular",
          theme: "primary",
          onClick: this.onPasswordRegisterSubmit.bind(this),
          children: "Continue"
        })]
      });
    }
  }, {
    key: "previousStep",
    value: function previousStep() {
      this.setState({
        step: 0
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
        children: [this.state.loading && /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {
          itemColor: "#FFFFFF",
          itemSize: 100
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ClipboardContainer, {
          ref: function ref(c) {
            return _this8.clipboard = c;
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ClipboardClip, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Clipboard, {
            children: [this.state.step !== 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(PreviousStepButton, {
              size: "large",
              round: true,
              color: "#ccc",
              onClick: this.previousStep.bind(this),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
                name: "arrow-left",
                color: "white",
                size: "large"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
              children: "Enter the Night Zoo"
            }), this.state.step === 0 && this.renderEnterUsernameForm(), this.state.step === 1 && this.renderExistingUserForm(), this.state.step === 2 && this.renderNewUserForm()]
          })]
        })]
      });
    }
  }]);

  return Login;
}(react.Component);

(0,defineProperty/* default */.Z)(Login, "defaultProps", {});


// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(66252);
// EXTERNAL MODULE: ./pages/zoo/login/graphql/queries/getUser.graphql
var getUser_graphql = __webpack_require__(72186);
var getUser_graphql_default = /*#__PURE__*/__webpack_require__.n(getUser_graphql);
// EXTERNAL MODULE: ./pages/zoo/login/graphql/mutations/initStudentPassword.graphql
var initStudentPassword_graphql = __webpack_require__(95167);
var initStudentPassword_graphql_default = /*#__PURE__*/__webpack_require__.n(initStudentPassword_graphql);
;// CONCATENATED MODULE: ./pages/zoo/login/graphql/useData.ts





var useData = function useData() {
  var client = (0,useApolloClient/* useApolloClient */.x)();

  var getUser = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(username) {
      var _yield$client$query, data;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return client.query({
                query: (getUser_graphql_default()),
                variables: {
                  input: {
                    username: username
                  }
                },
                fetchPolicy: 'network-only'
              });

            case 2:
              _yield$client$query = _context.sent;
              data = _yield$client$query.data;
              return _context.abrupt("return", data);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getUser(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var initStudentPassword = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(user, password) {
      var _yield$client$mutate, data;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return client.mutate({
                mutation: (initStudentPassword_graphql_default()),
                variables: {
                  user: user,
                  password: password
                }
              });

            case 2:
              _yield$client$mutate = _context2.sent;
              data = _yield$client$mutate.data;
              return _context2.abrupt("return", data);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function initStudentPassword(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  return {
    getUser: getUser,
    initStudentPassword: initStudentPassword
  };
};
// EXTERNAL MODULE: ./providers/Authentication/index.ts
var Authentication = __webpack_require__(34170);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/ModalProvider/index.state.tsx
var index_state = __webpack_require__(14896);
// EXTERNAL MODULE: ./node_modules/nzk-react-components/dist/esm/icons/Nzk.js
var Nzk = __webpack_require__(62116);
// EXTERNAL MODULE: ./components/UI/Link.js
var Link = __webpack_require__(92327);
// EXTERNAL MODULE: ./components/UIv2/Modal/index.tsx + 1 modules
var Modal = __webpack_require__(1536);
;// CONCATENATED MODULE: ./pages/zoo/login/components/NotAChildModal.tsx







var Overlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "NotAChildModal__Overlay",
  componentId: "sc-1oclkb1-0"
})(["position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,0.6);z-index:10;display:flex;justify-content:center;align-items:center;> :first-child{min-height:0 !important;padding-bottom:40px;}.title{font-size:36px;font-family:'Rammetto One';text-align:center;color:#fff;margin-bottom:20px;}.actions{display:flex;flex-direction:column;> *{display:flex;flex-direction:column;margin-bottom:20px;}> :last-child{margin-bottom:0;}}"]);
var NotAChildModal_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "NotAChildModal__Wrapper",
  componentId: "sc-1oclkb1-1"
})(["background-color:#fff;"]);

var NotAChildModal = function NotAChildModal() {
  var modal = (0,index_state/* useModalState */.X)();

  var dismiss = function dismiss() {
    modal.close('not-a-child-modal');
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Overlay, {
    onClick: function onClick(e) {
      e.stopPropagation();
      dismiss();
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      title: "Not a child?",
      enterAnimationDelay: 0,
      description: "Log in as",
      dismiss: dismiss,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "actions",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://dashboard.nightzookeeper.com/login",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            size: "large",
            theme: "confirm",
            children: "Parent"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
          to: "/dashboard/login",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            size: "large",
            theme: "primary",
            onClick: dismiss,
            children: "Teacher"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var components_NotAChildModal = (NotAChildModal);
;// CONCATENATED MODULE: ./pages/zoo/login/index.page.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexpage__Header",
  componentId: "sc-168vjqh-0"
})(["position:fixed;top:0;left:0;width:100%;display:flex;justify-content:space-between;z-index:1;padding:5px 15px;align-items:center;"]);

var LoginPage = function LoginPage() {
  var data = useData();
  var client = (0,useApolloClient/* useApolloClient */.x)();
  var router = (0,next_router.useRouter)();
  var modal = (0,index_state/* useModalState */.X)();

  var _useAuthentication = (0,Authentication/* useAuthentication */.J)(),
      login = _useAuthentication.login,
      isLoggedIn = _useAuthentication.isLoggedIn;

  (0,react.useEffect)(function () {
    if (isLoggedIn) {
      var params = new URLSearchParams(location.search);
      var redirectTo = params.get('redirectTo') || '/zoo/map';
      router.replace(redirectTo);
    }
  }, [isLoggedIn]);

  var onNotAChild = function onNotAChild() {
    modal.open( /*#__PURE__*/(0,jsx_runtime.jsx)(components_NotAChildModal, {}), 'not-a-child-modal');
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Header, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://www.nightzookeeper.com",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Nzk/* default */.Z, {
            height: 60,
            width: 60
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          size: "small",
          theme: "primary",
          onClick: onNotAChild,
          children: "Not a child?"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Login, _objectSpread(_objectSpread({}, data), {}, {
      client: client,
      login: login,
      router: router,
      isLoggedIn: isLoggedIn
    }))]
  });
};

LoginPage.getLayout = function (page) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: page
  });
};

/* harmony default export */ var index_page = (LoginPage);

/***/ }),

/***/ 94840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zoo/login",
      function () {
        return __webpack_require__(1163);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9920,1123,7032,9774,2888,179], function() { return __webpack_exec__(94840); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);